// Vendors
import axios from 'axios';

const DispatchUnreadMsgAmount = () => {
  const formData = new FormData();
  formData.append('action', 'wl_get_unread_msgs_amount');

  axios({
    method: 'POST',
    url: window.wlPipConfig.ajaxUrl,
    data: formData
  })
    .then((data) => {
      // dispatched event picked up by pip.js
      window.dispatchEvent(
        new CustomEvent('wlUpdateUnreadMessages', { detail: data.data })
      );
    })
    .catch((error) => {
      console.log(error);
    });
};

export default DispatchUnreadMsgAmount;
